import { useQuery } from "react-query";
import { locationMenuService } from "../services";

const getTags = async () => {
  const response = await locationMenuService.getTags()
  return response.data.data;
};

export default function useGetTags() {
  return useQuery(
    ["filterTags"], // Change from string to array for consistency
    () => getTags(),
    {
      staleTime: Infinity,    // Inherits global if not defined, but good to be explicit
      refetchOnMount: false,  // Prevents the API call on refresh
    }
  );
}